import React from 'react';
import { TextBlock } from '@thd-olt-component-react/loading-placeholder';
import { Card, CardBody } from '@one-thd/sui-atomic-components';

export const ProjectTilePlaceholder = () => {
  return (
    <div className="sui-w-full" data-component="ProjectTilePlaceholder">
      <Card className="sui-grid sui-rounded-md sui-shadow-base" data-testid="project-tile-placeholder">
        <TextBlock rows={3} color="#E1E1E1" widths={[25, 50, 35]} />
        <CardBody>
          <div className="sui-grid sui-grid-cols-3 sui-gap-2">
            {
              [1, 2, 3].map((number, index) => {
                return (
                  <div
                    // eslint-disable-next-line tailwindcss/no-arbitrary-value
                    className="sui-w-full"
                    key={`project-tile-placeholder-thumbnail-${number}`}
                  >
                    <div className="sui-aspect-square sui-w-full sui-bg-strong" />
                  </div>
                );
              })
            }
          </div>
        </CardBody>
        <TextBlock rows={2} color="#E1E1E1" widths={[50, 50]} />
      </Card>
    </div>
  );
};

ProjectTilePlaceholder.displayName = 'ProjectTilePlaceholder';